import { apiClient } from "../config";

async function archiveOrRestoreType(id: any, status: any) {
  const url = `/admin/types/${id}/archive`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default archiveOrRestoreType;
